import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { withRouter, useHistory } from "react-router-dom";

import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
  showRightSidebarAction,
  editLoginUserData
} from "../../store/actions";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import RightSidebar from "../CommonForBoth/RightSidebar";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';

import axios from 'axios';
import CryptoJS from 'crypto-js';
import useDecryptedAuth from "../../Utils/useDecryptedAuth";


const Layout = props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const decryptedAuth = useDecryptedAuth();
  // const {
  //   isPreloader,
  //   leftSideBarThemeImage,
  //   layoutWidth,
  //   leftSideBarType,
  //   topbarTheme,
  //   showRightSidebar,
  //   leftSideBarTheme,
  // } = useSelector(state => ({
  //   isPreloader: state.Layout.isPreloader,
  //   leftSideBarThemeImage: state.Layout.leftSideBarThemeImage,
  //   leftSideBarType: state.Layout.leftSideBarType,
  //   layoutWidth: state.Layout.layoutWidth,
  //   topbarTheme: state.Layout.topbarTheme,
  //   showRightSidebar: state.Layout.showRightSidebar,
  //   leftSideBarTheme: state.Layout.leftSideBarTheme,
  // }));
  const selectLayoutData = createSelector(
    state => state.Layout.isPreloader,
    state => state.Layout.leftSideBarThemeImage,
    state => state.Layout.leftSideBarType,
    state => state.Layout.layoutWidth,
    state => state.Layout.topbarTheme,
    state => state.Layout.showRightSidebar,
    state => state.Layout.leftSideBarTheme,
    (
      isPreloader,
      leftSideBarThemeImage,
      leftSideBarType,
      layoutWidth,
      topbarTheme,
      showRightSidebar,
      leftSideBarTheme
    ) => ({
      isPreloader,
      leftSideBarThemeImage,
      leftSideBarType,
      layoutWidth,
      topbarTheme,
      showRightSidebar,
      leftSideBarTheme
    })
  );
  const {
    isPreloader,
    leftSideBarThemeImage,
    leftSideBarType,
    layoutWidth,
    topbarTheme,
    showRightSidebar,
    leftSideBarTheme
  } = useSelector(selectLayoutData);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile));
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile));
    }
  };

  //hides right sidebar on body click
  const hideRightbar = (event) => {
    var rightbar = document.getElementById("right-bar");
    //if clicked in inside right bar, then do nothing
    if (rightbar && rightbar.contains(event.target)) {
      return;
    } else {
      //if clicked in outside of rightbar then fire action for hide rightbar
      dispatch(showRightSidebarAction(false));
    }
  };

  /*
  layout  settings
  */

  useEffect(() => {
    //init body click event fot toggle rightbar
    document.body.addEventListener("click", hideRightbar, true);

     
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(changeLayout("vertical"));
  }, [dispatch]);

  useEffect(() => {
    if (leftSideBarTheme) {
      dispatch(changeSidebarTheme(leftSideBarTheme));
    }
  }, [leftSideBarTheme, dispatch]);

  useEffect(() => {
    if (leftSideBarThemeImage) {
      dispatch(changeSidebarThemeImage(leftSideBarThemeImage));
    }
  }, [leftSideBarThemeImage, dispatch]);

  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth));
    }
  }, [layoutWidth, dispatch]);

  useEffect(() => {
    if (leftSideBarType) {
      dispatch(changeSidebarType(leftSideBarType));
    }
  }, [leftSideBarType, dispatch]);

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme));
    }
  }, [topbarTheme, dispatch]);


  const handleLoadVerifyAuth = async () => {
    const jsonpar = JSON.stringify({
      refreshtoken: decryptedAuth.refreshtoken,
    });
    const headers = {
      'Content-Type': 'application/json',
      'bcbqtoken': process.env.REACT_APP_TOKEN_SECRET,
      'accesstoken': 'Bearer ' + decryptedAuth.accesstoken,
      'lang': 'eng',
    }
    axios.post(process.env.REACT_APP_API_URL + process.env.REACT_APP_API_PREFIX + 'verify-auth', 
    {
      data: CryptoJS.AES.encrypt(jsonpar, process.env.REACT_APP_ADMIN_TOKEN_SECRET).toString(),
    }, 
    {
      headers: headers
    })
    .then(async function (res) {
      res = res.data;

      if (res.code === 200) {
        if(res.data) {
          let bytes = CryptoJS.AES.decrypt(res.data, process.env.REACT_APP_ADMIN_TOKEN_SECRET);
          let originalText = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

          const authAdmin = {
            ...decryptedAuth,
            accesstoken: originalText.accesstoken
          }
          const cipherText = CryptoJS.AES.encrypt(JSON.stringify(authAdmin), process.env.REACT_APP_ADMIN_TOKEN_SECRET).toString();
          localStorage.setItem("authAdmin", cipherText);
        }
      } else {
        history.push('/logout', { code: 401, status: 'error', message: res.message });
      }
    })
    .catch(function (error) {
      console.error("Error : ", error);
    });
  }
  React.useEffect(() => {
    handleLoadVerifyAuth();
  }, []);


  return (
    <React.Fragment>
      {/* <div id="preloader">
        <div id="status">
          <div className="spinner-chase">
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
          </div>
        </div>
      </div> */}

      <div id="layout-wrapper">
        <Header toggleMenuCallback={toggleMenuCallback} />
        <Sidebar
          theme={leftSideBarTheme}
          type={leftSideBarType}
          isMobile={isMobile}
        />
        <div className="main-content">{props.children}</div>
        <Footer />
      </div>
      {showRightSidebar ? <RightSidebar /> : null}
    </React.Fragment>
  );
};

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarThemeImage: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.object,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarThemeImage: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
};

export default withRouter(Layout);
